import {
	isEnabledDefaults,
	setDisabledStateOfLockableAttributeControlsWithDefaultValues
} from '@/core/core_components/form/form'
import { showNextTab } from '@/core/shared'
import { copyComponent, deleteComponent } from '@/core/item_assistance/creatingNewComponents'
import { showLangsList } from '@/core/input_controls/sleditor/sleditor'
import { clearFilters } from '@/core/filters/filtersSupport'
import { search } from '@/core/filters/filters'

export function enableAllHotkeysForAttributeEditors () {
	enableHotkeysForMultipleAttributes()
	enableHotkeysForSlAttributes()
}

export function enableAllHotkeysForAttributeGroups () {
	enableHotkeysForGroupsNavigation()
	enableHotkeyForShowHideGroups()
}

function enableHotkeysForGroupsNavigation () {
	var eventHandlers = {}
	eventHandlers['keydown.Ctrl_right'] = function () {
		showNextTab(1)
		return false
	}
	eventHandlers['keydown.Ctrl_left'] = function () {
		showNextTab(-1)
		return false
	}
	$(document).on(eventHandlers, '*')
}

function enableHotkeyForShowHideGroups () {
	$(document).on('keydown.Alt_g', '*', null, function () {
		$('#sidebar_groups').click()
		return false
	})
}

export function enableHotkeyForSave () {
	$(document).on('keydown.Alt_s', '*', null, function () {
		$('#sidebar_save').click()
		return false
	})
}

export function enableHotkeyForEdit () {
	$(document).on('keydown.Alt_e', '*', null, function () {
		$('#sidebar_edit').click()
		return false
	})
}

export function enableHotkeyForDefaultValues () {
	$(document).on('keydown.Alt_d', '*', null, function () {
		setDisabledStateOfLockableAttributeControlsWithDefaultValues(isEnabledDefaults())
		return false
	})
}

function enableHotkeysForMultipleAttributes () {
	var eventHandlers = {}
	eventHandlers['keydown.Alt_insert'] = function () {
		var elementAreaId = $(this).closest('.multiple-attribute').attr('id')
		var elementId = elementAreaId.substring(0, elementAreaId.length - 6)
		copyComponent(elementId, false, true)

		$(this).closest('.multiple-attribute').find('.row').children().last().children().find('.multiple-hotkey').focus()
		return false
	}
	eventHandlers['keydown.Alt_del'] = function () {
		var area = $(this).closest('.multiple-attribute')
		var delElem = $(this).closest('[data-attribute-type = single]')
		var curIndex = $(delElem).attr('data-attribute-index') - 1
		deleteComponent($(area), $(delElem))

		var focusedElement = $(area).find('.row').children().eq(curIndex).children().find('.multiple-hotkey')
		if (!focusedElement.length) {
			focusedElement = $(area).find('.row').children().eq(curIndex - 1).children().find('.multiple-hotkey')
		}
		$(focusedElement).focus()
		return false
	}
	$(document).on(eventHandlers, '.multiple-hotkey')
}

function enableHotkeysForSlAttributes () {
	var eventHandlers = {}
	eventHandlers['keydown.Alt_insert'] = function () {
		var elementAreaId = $(this).closest('.sl-editor').attr('id')
		var elementId = elementAreaId.substring(0, elementAreaId.length - 6)
		showLangsList(elementId, $(this))
		return false
	}
	eventHandlers['keydown.Alt_del'] = function () {
		var area = $(this).closest('.sl-editor')
		var delElem = $(this).closest('[data-attribute-type = single]')
		var curIndex = $(delElem).attr('data-attribute-index') - 1
		deleteComponent($(area), $(delElem))

		var focusedElement = $(area).find('.row').children().eq(curIndex).children().find('.sl-hotkey')
		if (!focusedElement.length) {
			focusedElement = $(area).find('.row').children().eq(curIndex - 1).children().find('.sl-hotkey')
		}
		$(focusedElement).focus()
		return false
	}
	$(document).on(eventHandlers, '.sl-hotkey')
}

export function enableHotkeyForSearch (itemStructure, table) {
	var enter = 13, del = 46
	$('.table_search').keydown(function (e) {
		if ($(e.target).is('button')) {
			e.preventDefault()
		}
	})
	$('.table_search').keyup(function (e) {
		if (e.keyCode == enter && e.shiftKey) {
			search(itemStructure, table)
		}
		if (e.keyCode == del && e.shiftKey) {
			clearFilters(itemStructure, table)
		}
		return false;
	});
}
